import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './Index.vue'
import apis from '@/libs/api'
import '../plugins/element.js'
import { setVm } from '@/libs/util'
import router from '@/libs/PcRouter.js'

Vue.use(VueRouter)
Vue.config.productionTip = false
Vue.prototype.$apis = apis
Vue.config.errorHandler = (err, vm) => {
  vm.$notify.error({
    message: err.message
  })
}

const vm = new Vue({
  render: h => h(App),
  router
})
setVm(vm)
vm.$mount('#app')
